import { Component, Input } from '@angular/core';

@Component({
    selector: 'gea-svg-warning',
    templateUrl: './warning.component.html',
    standalone: false
})
export class WarningComponent {

  @Input() size: number = 16

}
